import { Theme } from '@mui/material/styles';

export default function Lists(theme: Theme): unknown {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            borderWidth: '0px !important',
          },
          '&.active': {
            backgroundColor: theme.palette.background.neutral,
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
  };
}
